import { palette } from './palette'
import { typography } from './textModels'

export type StyledThemeFn = ({ theme }: WithTheme) => string

const fontFamily = {
	SBSansText: "'SBSansText', 'Open Sans', sans-serif",
	SBSansDisplay: "'SBSansDisplay', 'Open Sans', sans-serif",
	SBSansInterface: "'SBSansInterface', 'Open Sans', sans-serif",
}
export type FontFamily = keyof typeof fontFamily

export function themeFontFamily(fontFamily: FontFamily) {
	return ({ theme }: WithTheme) => theme.font.fontFamily[fontFamily]
}

const fontWeight = {
	SBSansText: {
		regular: '400',
		semibold: '600',
	},
	SBSansInterface: {
		regular: '400',
		semibold: '600',
	},
	SBSansDisplay: {
		regular: '400',
		semibold: '600',
	},
}
export type FontWeight = keyof typeof fontWeight.SBSansText

export function themeFontWeight(fontFamily: FontFamily, fontWeight: FontWeight): StyledThemeFn {
	return ({ theme }: WithTheme) => theme.font.fontWeight[fontFamily][fontWeight]
}

export type FontColorName = keyof typeof palette
export type FontColorTypeGray = keyof typeof palette.grey
export type FontColorBase = keyof typeof palette.base
export type FontColorSocial = keyof typeof palette.social
export type FontColorMalachite = keyof typeof palette.malachite
export function themeFontColor(name: 'grey', type: FontColorTypeGray): StyledThemeFn
export function themeFontColor(name: 'base', type: FontColorBase): StyledThemeFn
export function themeFontColor(name: 'social', type: FontColorSocial): StyledThemeFn
export function themeFontColor(name: 'malachite', type: FontColorMalachite): StyledThemeFn
export function themeFontColor(
	name: FontColorName,
	type: FontColorTypeGray | FontColorBase | FontColorSocial | FontColorMalachite
) {
	return ({ theme }: WithTheme) => theme.colors[name][type]
}

export type FontModelsName = keyof typeof typography
export type FontModelsTypeHeading = keyof typeof typography.heading
export type FontModelsTypeText = keyof typeof typography.text
export type FontModelsTypeNotAdaptive = keyof typeof typography.notAdaptive
export function themeFontModels(name: 'heading', type: FontModelsTypeHeading): StyledThemeFn
export function themeFontModels(name: 'text', type: FontModelsTypeText): StyledThemeFn
export function themeFontModels(name: 'notAdaptive', type: FontModelsTypeNotAdaptive): StyledThemeFn
export function themeFontModels(
	name: FontModelsName,
	type: FontModelsTypeHeading | FontModelsTypeText | FontModelsTypeNotAdaptive
): StyledThemeFn {
	return ({ theme }: WithTheme) => theme.fontModels[name][type]
}

export const themeObject = {
	font: {
		fontFamily,
		fontWeight,
	},
	colors: palette,
	fontModels: typography,
}

export type Theme = typeof themeObject
export type WithTheme = {
	theme: Theme
}
